import * as React from "react";
import {
  Input,
  Col,
  Form,
  Checkbox,
  Row,
  Upload,
  Button,
  Divider,
  Space,
  Tooltip
} from "antd";
import { FormInstance } from "antd/lib/form";
import TextArea from "antd/lib/input/TextArea";
import SelectInput from "../../../core/ui/components/SelectInput";
import { TAttachmentTypePresentationModel } from "../../../organisations/presenter/model/AttachmentTypePresentationModel";
import { UploadOutlined } from "@ant-design/icons";
import { TAttachmentPresentationModel } from "../../presenter/model/AttachmentPresentationModel";
import { ContentTypes } from "../../common/Constants";
import { AttachmentType } from "../../../attachmentType/common/Constants";
const FormFields = {
  ID: "id",
  ORGANISATION_ID: "organisationId",
  CONTENT_TYPE_ID: "attachmentContentId",
  NAME: "name",
  VALID: "valid",
  ATTACHMENT_TYPE_ID: "attachmentTypeId",
  CONTENT: "content",
  DESCRIPTION: "description",
  ANONIMIZED: "anonymised",
  FILE: "file",
  ORIGINAL_ATTACHMENT_ID: "originalAttachmentId"
};
export interface State {
  selectedAttachmentEntryMode: "0" | "1" | "2";
  fileUploaded?: boolean;
  anonymousFileUploaded?: boolean;
  anonymisationVisible?: boolean;
}

export interface Props {
  translate: any;
  form: FormInstance;
  rowData?: TAttachmentPresentationModel;
  attachmentTypes: TAttachmentTypePresentationModel[];
  contentType?: any[];
  setFileValue;
  uploadedFile;
  caseLawDocumentId?: number;
  anonimisedUploadedFile;
  setAnonymisedFileValue;
}
export default class CaseLawDocumentAttachmentForm extends React.Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      selectedAttachmentEntryMode:
        this.props.rowData && Object.keys(this.props.rowData).length > 0
          ? this.props.rowData?.contentType?.code ===
            ContentTypes.URL_CONTENT_TYPE
            ? "0"
            : "1"
          : "2",
      fileUploaded: false,
      anonymousFileUploaded: false,
      anonymisationVisible:
        this.props.rowData?.attachmentType?.anonymisationRequired
    };
  }
  onChange = (file) => {
    this.props.setFileValue(file);

    let form = this.props.form;
    form.setFieldsValue({
      [FormFields.ANONIMIZED]: true
    });

    this.setState({ fileUploaded: file ? true : false });
  };
  onChangeAnonymisedFile = (file) => {
    this.props.setAnonymisedFileValue(file);

    let form = this.props.form;
    form.setFieldsValue({
      [FormFields.ANONIMIZED]: true
    });

    this.setState({ anonymousFileUploaded: file ? true : false });
  };

  renderAttachmentField = () => {
    const { uploadedFile, rowData, translate } = this.props;
    if (uploadedFile) {
      if (rowData && Object.keys(rowData).length > 0) {
        return (
          <Input
            defaultValue={uploadedFile.name}
            disabled
            addonBefore={<i className="fas fa-file-alt"></i>}
            addonAfter={
              <Space size="middle">
                <Tooltip title={translate("editors.attachments.download")}>
                  <Button
                    type="link"
                    size="small"
                    href={`/api/case-law-documents/attachments/${rowData.id}/download`}
                  >
                    <i className="fa fa-download" style={{ marginRight: 0 }} />
                  </Button>
                </Tooltip>
              </Space>
            }
          />
        );
      } else {
        return (
          <Input
            disabled
            defaultValue={uploadedFile?.name ?? undefined}
            addonBefore={<i className="fas fa-file-alt"></i>}
            addonAfter={
              <Tooltip title={translate("editors.attachments.delete")}>
                <Button
                  danger
                  type="link"
                  size="small"
                  onClick={() => this.onChange(undefined)}
                >
                  <i className="fa fa-trash" style={{ marginRight: 0 }} />
                </Button>
              </Tooltip>
            }
          ></Input>
        );
      }
    } else {
      if (rowData && Object.keys(rowData).length > 0) {
        if (rowData.originalAttachmentId) {
          return (
            <Input
              defaultValue={rowData.name}
              disabled
              addonBefore={<i className="fas fa-file-alt"></i>}
              addonAfter={
                <Space size="middle">
                  <Tooltip title={translate("editors.attachments.download")}>
                    <Button
                      type="link"
                      size="small"
                      href={`/api/case-law-documents/attachments/${rowData.originalAttachmentId}/download`}
                    >
                      <i
                        className="fa fa-download"
                        style={{ marginRight: 0 }}
                      />
                    </Button>
                  </Tooltip>
                </Space>
              }
            />
          );
        } else {
          return (
            <Input
              defaultValue={rowData.name}
              disabled
              addonBefore={<i className="fas fa-file-alt"></i>}
              addonAfter={
                <Space size="middle">
                  <Tooltip title={translate("editors.attachments.download")}>
                    <Button
                      type="link"
                      size="small"
                      href={`/api/case-law-documents/attachments/${rowData.id}/download`}
                    >
                      <i
                        className="fa fa-download"
                        style={{ marginRight: 0 }}
                      />
                    </Button>
                  </Tooltip>
                </Space>
              }
            />
          );
        }
      } else {
        return (
          <Upload
            onChange={(e) => this.onChange(e.file)}
            beforeUpload={(file, fileList) => {
              return false;
            }}
            onRemove={(file) => {
              this.setState({
                fileUploaded: false
              });
            }}
            showUploadList={{
              showRemoveIcon: true
            }}
            fileList={this.props.uploadedFile ? [this.props.uploadedFile] : []}
          >
            {!this.state.fileUploaded && (
              <Button type={"default"}>
                <UploadOutlined />
                {this.props.translate("form_details.select_document")}
              </Button>
            )}
          </Upload>
        );
      }
    }
  };
  renderAttachmentTypeOptions = () => {
    const { rowData, attachmentTypes } = this.props;
    if (rowData && Object.keys(rowData).length > 0) {
      let attachmentTypeList = attachmentTypes.filter(
        (item) =>
          item?.contentType?.code === rowData?.attachmentType?.contentType?.code
      );
      if (rowData.attachmentTypeName !== AttachmentType.DECISION) {
        return attachmentTypeList.filter(
          (item) => item.name !== AttachmentType.DECISION
        );
      }
      return attachmentTypeList;
    } else {
      return attachmentTypes;
    }
  };
  renderAnonymisedFileInputField = () => {
    let { anonimisedUploadedFile, translate, rowData } = this.props;
    if (anonimisedUploadedFile) {
      return (
        <Input
          defaultValue={anonimisedUploadedFile.name}
          disabled
          addonBefore={<i className="fas fa-file-alt"></i>}
          addonAfter={
            <Space size="middle">
              <Tooltip title={translate("editors.attachments.download")}>
                <Button
                  type="link"
                  size="small"
                  href={`/api/case-law-documents/attachments/${rowData?.id}/download`}
                >
                  <i className="fa fa-download" style={{ marginRight: 0 }} />
                </Button>
              </Tooltip>
              <Tooltip title={translate("editors.attachments.delete")}>
                <Button
                  danger
                  type="link"
                  size="small"
                  onClick={() => this.onChangeAnonymisedFile(undefined)}
                >
                  <i className="fa fa-trash" style={{ marginRight: 0 }} />
                </Button>
              </Tooltip>
            </Space>
          }
        />
      );
    } else {
      return (
        <Upload
          onChange={(e) => this.onChangeAnonymisedFile(e.file)}
          beforeUpload={(file, fileList) => {
            return false;
          }}
          showUploadList={{
            showRemoveIcon: true
          }}
          fileList={
            anonimisedUploadedFile?.file &&
            Object.keys(anonimisedUploadedFile?.file).length !== 0
              ? [anonimisedUploadedFile?.file]
              : []
          }
        >
          {!this.state.anonymousFileUploaded && (
            <Button type={"default"}>
              <UploadOutlined />
              {translate("form_details.select_document")}
            </Button>
          )}
        </Upload>
      );
    }
  };

  render() {
    const { translate, rowData, form, attachmentTypes } = this.props;

    return (
      <Form layout={"vertical"} form={form}>
        <Form.Item
          style={{ display: "none" }}
          name={FormFields.ID}
          initialValue={rowData?.id}
        >
          <Input />
        </Form.Item>
        <Form.Item
          style={{ display: "none" }}
          name={FormFields.ORIGINAL_ATTACHMENT_ID}
          initialValue={rowData?.originalAttachmentId}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={translate("editors.attachments.valid")}
          style={{ display: "none" }}
          name={FormFields.VALID}
          valuePropName={"checked"}
          initialValue={rowData?.valid ?? true}
        >
          <Checkbox />
        </Form.Item>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24}>
            <Form.Item
              label={translate("editors.attachments.name")}
              className={"mb-0"}
              name={FormFields.NAME}
              initialValue={rowData?.name}
              rules={[
                {
                  required: true,
                  message: translate("editors.attachments.required_messages", {
                    field: translate("editors.attachments.name")
                  })
                }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col
            xs={24}
            sm={4}
            style={{
              display: "none",
              marginTop: 20,
              alignItems: "center"
            }}
          >
            <Form.Item
              label={translate("editors.attachments.anonymised")}
              className={"png-form-item-horizontal-checkbox mb-0"}
              name={FormFields.ANONIMIZED}
              valuePropName={"checked"}
              initialValue={rowData?.anonymised ?? false}
            >
              <Checkbox />
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={[16, 16]}
          className={"content-section-modal-borderless pb-0"}
        >
          <Col xs={24} sm={24}>
            <Form.Item
              label={translate("editors.attachments.attachment_type")}
              className={"mb-0"}
              name={FormFields.ATTACHMENT_TYPE_ID}
              initialValue={
                rowData?.attachmentTypeId
                  ? rowData?.attachmentTypeId
                  : rowData?.id
              }
              rules={[
                {
                  required: true,
                  message: translate("editors.attachments.required_messages", {
                    field: translate("editors.attachments.attachment_type")
                  })
                }
              ]}
            >
              <SelectInput
                placeholder={translate(
                  "editors.attachments.select_attachment_type"
                )}
                allowClear
                showSearch={true}
                notFoundContent={translate("search.no_data")}
                selectOptionKey={"id"}
                selectOptionValue={"name"}
                selectOptions={this.renderAttachmentTypeOptions()}
                onChange={(item) => {
                  let element = attachmentTypes.find((i) => i.id === item);
                  element?.contentType?.code ===
                    ContentTypes.URL_CONTENT_TYPE && this.onChange(undefined);
                  this.setState({
                    selectedAttachmentEntryMode:
                      element?.contentType?.code ===
                      ContentTypes.URL_CONTENT_TYPE
                        ? "0"
                        : "1",
                    anonymisationVisible: element?.anonymisationRequired
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col
            xs={24}
            sm={24}
            style={{
              display:
                this.state.selectedAttachmentEntryMode === "0"
                  ? "block"
                  : "none"
            }}
          >
            <Form.Item
              className={"mb-0"}
              name={FormFields.CONTENT}
              initialValue={rowData?.content}
              rules={[
                {
                  required:
                    this.state.selectedAttachmentEntryMode === "0" ||
                    rowData?.content !== undefined
                      ? true
                      : false,
                  message: translate("editors.attachments.required_messages", {
                    field: translate("editors.attachments.attachment_type")
                  })
                }
              ]}
            >
              <Input
                addonBefore={<i className="fas fa-globe"></i>}
                placeholder={translate("editors.attachments.url")}
              />
            </Form.Item>
          </Col>
          <div
            style={{
              display:
                this.state.selectedAttachmentEntryMode === "1"
                  ? "block"
                  : "none"
            }}
          >
            <Col md={24} sm={24} xs={24}>
              <div className="ant-col ant-form-item-label">
                <label
                  style={{ height: 14 }}
                  title={translate("editors.attachments.anonymised")}
                >
                  {translate("editors.attachments.original_content")}
                </label>
              </div>
            </Col>
            <Col md={24} sm={24} xs={24}>
              {this.renderAttachmentField()}
            </Col>
          </div>
          {this.state.anonymisationVisible &&
          this.state.selectedAttachmentEntryMode === "1" ? (
            <>
              <Col md={24} sm={24} xs={24}>
                <div className="ant-col ant-form-item-label">
                  <label
                    title={translate("editors.attachments.content")}
                    style={{ height: 14 }}
                  >
                    {translate("editors.attachments.content")}
                  </label>
                </div>
              </Col>

              <Col md={24} sm={24} xs={24}>
                {this.renderAnonymisedFileInputField()}
              </Col>
            </>
          ) : null}
          <Col xs={24} sm={24}>
            <Divider style={{ marginTop: 12, marginBottom: 12 }} />
            <Form.Item
              label={translate("editors.attachments.description")}
              className={"mb-0"}
              name={FormFields.DESCRIPTION}
              initialValue={rowData?.description}
            >
              <TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}
